import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const navItems = [
  { name: 'Home', to: '/', scrollTo: 'hero' },
  { name: 'Work', to: '/', scrollTo: 'projects' },
  { name: 'About', to: '/', scrollTo: 'about' },
  { name: 'Writing', to: '/blog' },
  { name: 'Contact', to: '/', scrollTo: 'contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleHomeClick = () => {
    if (isMainPage) window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? 'border-border bg-background/85 shadow-[0_8px_30px_rgba(0,0,0,0.24)] backdrop-blur-xl'
          : 'border-white/10 bg-background/55 backdrop-blur-lg'
      }`}
    >
      <div className="max-w-6xl mx-auto h-16 px-6 flex items-center justify-between">
        <div className="flex items-center">
          {isMainPage ? (
            <button
              onClick={handleHomeClick}
              className="font-display text-base font-semibold tracking-tight text-foreground hover:opacity-70 transition-opacity"
            >
              Mohan Balaji
            </button>
          ) : (
            <RouterLink to="/" className="font-display text-base font-semibold tracking-tight text-foreground hover:opacity-70 transition-opacity">
              Mohan Balaji
            </RouterLink>
          )}
        </div>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) =>
            isMainPage && item.scrollTo ? (
              <Link
                key={item.name}
                to={item.scrollTo}
                spy
                smooth
                offset={-64}
                duration={500}
                className={`rounded-lg px-3 py-2 text-sm transition-colors cursor-pointer ${
                  item.name === 'Contact'
                    ? 'border border-primary/30 bg-primary/10 text-foreground hover:bg-primary hover:text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
                onClick={item.name === 'Home' ? handleHomeClick : undefined}
              >
                {item.name}
              </Link>
            ) : (
              <RouterLink
                key={item.name}
                to={item.to}
                className={`rounded-lg px-3 py-2 text-sm transition-colors ${
                  item.name === 'Contact'
                    ? 'border border-primary/30 bg-primary/10 text-foreground hover:bg-primary hover:text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                {item.name}
              </RouterLink>
            )
          )}
        </nav>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden p-2 -mr-2 text-foreground"
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 border-t border-white/10 ${
          isOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0 border-transparent'
        }`}
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col gap-1">
          {navItems.map((item) =>
            isMainPage && item.scrollTo ? (
              <Link
                key={item.name}
                to={item.scrollTo}
                spy
                smooth
                offset={-64}
                duration={500}
                onClick={() => {
                  setIsOpen(false);
                  if (item.name === 'Home') handleHomeClick();
                }}
                className="rounded-lg px-3 py-2 text-sm text-muted-foreground hover:bg-muted hover:text-foreground cursor-pointer"
              >
                {item.name}
              </Link>
            ) : (
              <RouterLink
                key={item.name}
                to={item.to}
                onClick={() => setIsOpen(false)}
                className="rounded-lg px-3 py-2 text-sm text-muted-foreground hover:bg-muted hover:text-foreground"
              >
                {item.name}
              </RouterLink>
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
